<ion-button
  [id]="triggerId"
  fill="outline"
  color="medium"
  class="popover-trigger-btn"
  [class.tight]="tight()"
>
  {{ getSelectedLabel() }}
  <ion-icon
    [name]="isPopoverOpen() ? 'chevron-up-outline' : 'chevron-down-outline'"
    slot="end"
  ></ion-icon>
</ion-button>

<ion-popover
  [trigger]="triggerId"
  triggerAction="click"
  mode="ios"
  #popover
  (didPresent)="onPopoverDidPresent()"
  (didDismiss)="onPopoverDidDismiss()"
  show-backdrop="false"
>
  <ng-template>
    <div class="popover-content">
      @for (option of options(); track option.value) {
        <button
          class="popover-option"
          [class.selected]="isSelected(option.value)"
          (click)="onSelectOption(option.value)"
        >
          {{ option.label }}
        </button>
      }
    </div>
  </ng-template>
</ion-popover>
